import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import ShiftCloseoutHistoryRow from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt/parts/ShiftCloseoutHistory/parts/ShiftCloseoutHistoryRow'
import { ShiftCloseoutHistoryItem } from '@/features/shiftCloseouts/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ShiftCloseoutHistoryProps {
    items: ShiftCloseoutHistoryItem[]
    layout: Layout
}

const ShiftCloseoutHistory: FC<ShiftCloseoutHistoryProps> = ({ items, layout }) => {
    const { t } = useTranslation()
    const { styles } = useStyles(stylesheet, { layout })

    return (
        <View style={styles.container}>
            {items.length === 0 ? (
                <View style={styles.emptyState}>
                    <Typography.Description style={styles.emptyStateText}>
                        {t('shiftCloseouts.history.empty')}
                    </Typography.Description>
                </View>
            ) : layout === 'extended' ? (
                <View style={styles.header} testID="shift-closeout-history-header">
                    <Typography.Description font="bold" size="tiny" style={styles.headerCell}>
                        {t('shiftCloseouts.history.date').toUpperCase()}
                    </Typography.Description>
                    <Typography.Description font="bold" size="tiny" style={styles.headerCell}>
                        {t('shiftCloseouts.history.revenue').toUpperCase()}
                    </Typography.Description>
                    <Typography.Description font="bold" size="tiny" style={styles.headerCell}>
                        {t('shiftCloseouts.history.createdBy').toUpperCase()}
                    </Typography.Description>
                </View>
            ) : null}

            {items.length > 0 && (
                <View style={styles.list}>
                    {items.map((item) => (
                        <ShiftCloseoutHistoryRow key={item.uuid} item={item} layout={layout} />
                    ))}
                </View>
            )}
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        gap: 8,
        borderColor: ColorEnum.GRAY_300,
        borderWidth: 1,
        backgroundColor: ColorEnum.GRAY_100,
        variants: {
            layout: {
                compact: {
                    padding: 12,
                    borderRadius: 16,
                },
                extended: {
                    padding: 16,
                    borderRadius: 12,
                },
            },
        },
    },
    header: {
        flexDirection: 'row',
        gap: 16,
        paddingLeft: 16,
        paddingRight: 72,
    },
    headerCell: {
        flex: 1,
        color: ColorEnum.GRAY_900,
        letterSpacing: 0.5,
    },
    emptyState: {
        alignItems: 'center',
        padding: 24,
    },
    emptyStateText: {
        color: ColorEnum.GRAY_600,
        textAlign: 'center',
    },
    list: {
        gap: 8,
    },
})

export default ShiftCloseoutHistory
